import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3042">
      <Navbar data-id="element-3043" />
      <main data-id="element-3044">
        <ConsularAffairs data-id="element-3045" />
      </main>
      <Footer data-id="element-3046" />
      <FeedbackPopup data-id="element-3047" />
    </div>;
}